import React, {useRef, useEffect, useState} from "react";
import {withGoogleMap, GoogleMap, Marker} from "react-google-maps"
//import MarkerClusterer from "react-google-maps/lib/components/addons/MarkerClusterer"
import MapStyles from './styles.json'
import useWindowDimensions from "../../hooks/useWindowDimensions";
//import { MarkerClusterer } from "@googlemaps/markerclusterer";

const FormGoogleMap = withGoogleMap((props) => {
    const mapRef = useRef();

    const { initialCenter, centerZoom } = props;
    const [center, setCenter] = useState(initialCenter)
    const [zoom, setZoom] = useState(centerZoom || 7)

    useEffect(() => {
        if (initialCenter.lat && initialCenter.lng) {
            setCenter(initialCenter);
            setZoom(centerZoom);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialCenter]);


  return (
    <GoogleMap
      ref={mapRef}
      zoom={zoom || 7}
      center={center}
      defaultOptions={{
        styles: MapStyles,
        gestureHandling: "greedy",
        maxZoom: 20,
        minZoom: 3,
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false}}
    >
      {props.children}
    </GoogleMap>
  );
});


const FormMap = props => {

    const {data, centerAddress, callback} = props;
    const [popupItem, setPopupItem] = useState(null)
    const [popupVisible, setPopupVisible] = useState(false)
    const [mouseCoordinates, setMouseCoordinates] = useState({x: 0, y: 0})
    const [mapMarkers, setMapMarkers] = useState([])
    const [centerZoom, setCenterZoom] = useState(5)

    const markerHandler = (item) => {
        callback(item);
    }

    const {width, height} = useWindowDimensions();

    const showPopup = (e, item) => {

        const {pageX, pageY} = e.domEvent;

        const finalX = (pageX + 150) < width ? pageX + 10 : pageX - 160;
        const finalY = (pageY + 250) < height ? pageY + 20 : -1;

        setMouseCoordinates({x: finalX, y: finalY});
        setPopupItem(item)
        setPopupVisible(true)
    }

    const hidePopup = () => {
        setPopupVisible(false)
    }

    useEffect(() => {
        setCenterZoom(centerZoom)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [centerAddress]);

    useEffect(() => {

        const anchor = new window.google.maps.Point(14, 14);
        const scaledSize =  new window.google.maps.Size(28, 28);

        const markers = (data)
            ? data.map((item, index) => {
                return <Marker key={index}
                               icon={{
                                   url: item.icon,
                                   anchor: anchor,
                                   scaledSize: scaledSize
                               }}
                               clickable={true}
                               onMouseOver={(e) => showPopup(e, item)}
                               onMouseOut={() => hidePopup()}
                               onClick={() => markerHandler(item)}
                               position={{ lat: item.lat, lng: item.lng }} />;

            })
            : [];
        setMapMarkers(markers)
       // const markerCluster = new MarkerClusterer({ map, markers });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);


    return (
        <div>
          <FormGoogleMap
            initialCenter={centerAddress}
            initialZoom={centerZoom}
            loadingElement={<div style={{ height: `100%`, width: `100%` }} />}
            containerElement={<div style={{ height: `100vh`, width: `100%` }} />}
            mapElement={<div style={{ height: `100%` }} />}
          >
              {mapMarkers}
          </FormGoogleMap>
            {popupVisible &&
                <div className='w-150 bg-white shadow p-absolute' style={{left: mouseCoordinates.x , ...(mouseCoordinates.y > -1 ? {top: mouseCoordinates.y} : {bottom: 10}), borderRadius: 10}}>
                    {popupItem?.Image && <img className='mb-5' width={150} height={150} src={popupItem?.Image[0].url} alt='pin' style={{objectFit: 'cover'}}/> }
                    {!popupItem?.Image && <div className='w-150 h-100 d-flex-center' style={{backgroundColor: '#df1212'}}><img className='mb-5' width={50} height={50} src={popupItem?.icon} alt='pin' style={{objectFit: 'cover'}}/></div> }
                    <div className='p-10'>
                        <p className='mb-5 fs-12'><strong>{popupItem.Name}</strong></p>
                        {popupItem.Services && <p className='fs-9'>{popupItem.Services.substring(0, 100) + (popupItem.Services.length > 100 ? '...' : '')}</p>}
                    </div>
                </div>}
        </div>
    )
}

export default FormMap
